
import { css } from 'lit';
export default css`
.accordion__item {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}

  .accordion__item:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 235, 246, var(--tw-bg-opacity));
}

  .accordion__item--icon {
  margin-left: auto;
}

  .accordion__item--icon {
  height: 1.25rem;
}

  .accordion__item--icon {
  width: 1.25rem;
}

  .accordion__item--icon {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .accordion__item--prompt-container {
  display: flex;
}

  .accordion__item--prompt-container {
  cursor: pointer;
}

  .accordion__item--prompt-container {
  align-items: center;
}

  .accordion__item--prompt-container {
  justify-content: space-between;
}

  .accordion__item--prompt-container {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

  .accordion__item--prompt-container {
  padding-left: 1rem;
}

  .accordion__item--prompt-container {
  padding-right: 1.25rem;
}

  .accordion__item--prompt-container {
    width: 100%;
  }

  .accordion__item--prompt-container:hover .accordion__item--icon {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

  .accordion__item--prompt {
  font-size: 1.25rem;
}

  .accordion__item--prompt {
    width: 90%;
  }

  .accordion__item--response {
  padding-left: 2.5rem;
}

  .accordion__item--response {
    width: 85%;
  }

  .accordion__item[open] {
  display: block;
}

  .accordion__item[open] .accordion__item--prompt-container {
  padding-bottom: 1rem;
}

  .accordion__item[open] .accordion__item--response {
      margin-bottom: 30px;
    }
`;